import '@babel/polyfill';
import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import router from './views/router';
import './registerServiceWorker';
import './global.scss';
import Logger from '@/services/Logger';




Vue.config.productionTip = false;


Logger.logLoaded();


new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
